






import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import GLoading from '@/components/GLoading.vue';
import { surveyAnalyzeModule } from '@/store/modules/frames/survey-analyze.module';

@Component({
  name: 'GSurveyChartCircle',
  components: { GLoading },
})
export default class GSurveyChartCircle extends mixins(GPageBase) {
  @Prop() competencyID: number;

  mounted() {}

  get options(): any {
    statisticsModule.surveyAnalysisCircleEchartService.addSeries(this.competencyID);
    return statisticsModule.surveyAnalysisCircleEchartService.options;
  }

  get loading(): boolean {
    return statisticsModule.loading;
  }

  get competencyName(): string {
    return surveyAnalyzeModule.competencyNameMap.get(this.competencyID);
  }
}
